import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataPoint, UpdatedTasksInterface } from 'Interfaces/DataPoint';

const INITIAL_STATE: UpdatedTasksInterface = {
  tasks: []
};

const updatedTasksSlice = createSlice({
  name: 'updatedTasks',
  initialState: INITIAL_STATE,
  reducers: {
    setUpdatedTasks(state, action: PayloadAction<DataPoint[]>) {
      return { tasks: state.tasks.concat(action.payload) };
    },
    clearUpdatedTasks(state, action: PayloadAction<DataPoint[]>) {
      const newTasks = state.tasks.map(v => {
        const found = action.payload.find(t => t.id === v.id && t.modified === v.modified);
        if (found) {
          return null;
        }
        return v;
      }).filter(t => t !== null);
      return {...state, tasks: newTasks};
    },
  },
});
export const { setUpdatedTasks, clearUpdatedTasks } = updatedTasksSlice.actions;
export default updatedTasksSlice.reducer;
